<template>
    <div class="main-wrapper px-3">
        <h3 class="text-white mt-3">{{ $t('setting.claimed_promotions') }}</h3>

        <!-- LOADING STATE -->
        <div
            v-if="isPromotionsFetching"
            class="d-flex justify-content-center align-items-center"
            style="gap: 8px; min-height: 200px;"
        >
            <van-loading type="spinner" />
            Loading...
        </div>

        <!-- EMPTY STATE -->
        <template v-else-if="!userClaimedPromotions.length">
            <div class="empty-wrap">
                <NoPromotions />
            </div>
        </template>

        <!-- PROMOTION LIST -->
        <template v-else>
            <div class="promo-list">
                <PromotionCard
                    v-for="(promotion, index) in userClaimedPromotions"
                    :key="index"
                    :promotion="promotion"
                />
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PromotionCard from '../components/PromotionCard.vue';
import NoPromotions from '../../promotions/components/NoPromotions.vue';

export default {
    components: {
        PromotionCard,
        NoPromotions
    },
    computed: {
        ...mapState('promotions', ['userClaimedPromotions', 'isPromotionsFetching'])
    },
    methods: {
        ...mapActions('promotions', ['fetchUserPromotions'])
    },
    async mounted() {
        try {
            await this.fetchUserPromotions();
        } catch (error) {
            this.$toast.fail('Something went wrong!');
        }
    }
}
</script>

<style scoped>
.body-bg {
    overflow-x: hidden;
}
</style>
